import Vue from 'vue'
Vue.directive('hover', {
  inserted(el, binding) {
    el?.addEventListener('mouseenter', function() {
      el.classList.add(binding.arg || 'hover')
    }, false)
    el?.addEventListener('mouseleave', function() {
      el.classList.remove(binding.arg || 'hover')
    })
  }
})